class FeatureTogglesService {
    private featureToggles: any;

    constructor() {
        this.featureToggles = (window as any).__env?.featureToggles || {};
    }

    isRegistrationEnabled(): boolean {
        return !!this.featureToggles.registrationEnabled;
    }

    isEsiaIntegrationEnabled(): boolean {
        return !!this.featureToggles.esiaIntegrationEnabled;
    }
}

export const featureTogglesService = new FeatureTogglesService();
